import { InternalAxiosRequestConfig } from 'axios';
import * as sessionStorage from '../utility/session.storage';
import { SESSION_SESSION_ID_KEY } from '../utility/session.storage.keys';
import { SESSION_ID_HEADER } from './api.constants';

export function updateAuthorizationHeader() {
  return (requestConfig: InternalAxiosRequestConfig) => {
    const sessionId = sessionStorage.read(SESSION_SESSION_ID_KEY);
    if (sessionId && requestConfig.headers?.[SESSION_ID_HEADER]) {
      requestConfig.headers[SESSION_ID_HEADER] = sessionId;
    }

    return requestConfig;
  };
}
